<div class="sidebar">
  <ul class="navigation-menu">
		<li>
			<a routerLink="/dashboard" routerLinkActive="active">
				<span class="link-title">Dashboard</span>
				<i class="mdi mdi-gauge link-icon"></i>
			</a>
		</li>
		<li>
			<a routerLink="/locations" routerLinkActive="active">
				<span class="link-title">Locations</span>
				<i class="mdi mdi-map-marker-circle link-icon"></i>
			</a>
		</li>
		<li>
			<a routerLink="/devices" routerLinkActive="active">
				<span class="link-title">Devices</span>
				<i class="mdi mdi-router-wireless link-icon"></i>
			</a>
		</li>
		<li>
			<a routerLink="/organizations" routerLinkActive="active">
				<span class="link-title">Organizations</span>
				<i class="mdi mdi-sitemap link-icon"></i>
			</a>
		</li>
		<li *ngIf="userService.userInfo.group.id === 1">
			<a routerLink="/admin" routerLinkActive="active">
				<span class="link-title">CB Admin</span>
				<i class="mdi mdi-ambulance link-icon"></i>
			</a>
		</li>
  </ul>
</div>
